/* eslint-disable */
// Ref: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
export function debounce(fn: Function, wait = 0) {
    let timeoutID: NodeJS.Timeout | undefined;

    function debouncedFn(...args: any[]) {
        // @ts-ignore:  error TS2683: 'this' implicitly has type 'any' because it does not have a type annotation.
        const context = this;

        if (timeoutID) clearTimeout(timeoutID);
        timeoutID = setTimeout(function () {
            timeoutID = undefined;
            fn.apply(context, args);
        }, wait);
    }

    debouncedFn.cancel = function () {
        if (timeoutID) clearTimeout(timeoutID);
        timeoutID = undefined;
    };

    return debouncedFn;
}
